import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import React, {Component} from 'react';

import AddFilter from './AddFilter';
import * as ObjectConst from '../../constants/Property';
import {updateField, setGeneralInformationValid} from '../../actions/CreatingObjectPage';
import classnames from "classnames";

const propTypes = {
    isActive: PropTypes.bool.isRequired
};

const defaultProps = {
    updateField: (objectId, updateFieldCommand) => {
    },
    setGeneralInformationValid: isGeneralInformationValid => {
    }
};

class GeneralInformation extends Component {
    state = {
        AREA: '',
        TERRACE: '',
        COUNT_BEDS: '',
        RANGE_TYPE: '',
        COUNT_GUEST: '',
        DESCRIPTION: '',
        DISPLAY_NAME: '',
        RENT_COMMENT: '',
        COUNT_BEDROOMS: '',
        COUNT_BATHROOM: '',
        TYPE_APARTMENT: ''
    };

    componentWillReceiveProps(nextProps) {
        const {
            creatingObjectPage: {
                createdObject: {
                    id,
                    props: {
                        area,
                        terrace,
                        countBeds,
                        rangeType,
                        countGuest,
                        countBedrooms,
                        typeApartment,
                        countBathrooms,

                    },
                    description: {
                        description,
                        displayName,
                        rentComment,
                        languageCode
                    }
                }
            }
        } = nextProps;

        if (id !== undefined) {
            this.setState({
                RANGE_TYPE: rangeType,
                DESCRIPTION: description,
                DISPLAY_NAME: displayName,
                RENT_COMMENT: rentComment,
                LANGUAGE_CODE: languageCode,
                TYPE_APARTMENT: typeApartment,
                AREA: area === 0 || area === '0' ? '' : area,
                TERRACE: terrace === 0 || terrace === '0' ? '' : terrace,
                COUNT_BEDS: countBeds === 0 || countBeds === '0' ? '' : countBeds,
                COUNT_GUEST: countGuest === 0 || countGuest === '0' ? '' : countGuest,
                COUNT_BEDROOMS: countBedrooms === 0 || countBedrooms === '0' ? '' : countBedrooms,
                COUNT_BATHROOM: countBathrooms === 0 || countBathrooms === '0' ? '' : countBathrooms
            });
        }
    }

    handleTypeClick(event, type) {
        event.preventDefault();

        const updateFieldCommand = {
            name: ObjectConst.FIELDS.TYPE,
            value: type
        };
        this.props.updateField(this.props.createdObject.id, updateFieldCommand);
    }

    updateField(event) {
        const name = event.currentTarget.name;
        let value = event.currentTarget.value;

        const updateFieldCommand = {
            name: name
        };

        switch (event.target.name) {
            case ObjectConst.FIELDS.AREA:
            case ObjectConst.FIELDS.TERRACE:
            case ObjectConst.FIELDS.COUNT_BEDS:
            case ObjectConst.FIELDS.COUNT_GUEST:
            case ObjectConst.FIELDS.COUNT_BEDROOMS:
            case ObjectConst.FIELDS.COUNT_BATHROOM:
                updateFieldCommand.value = value.length === 0 ? '0' : value;
                break;
            default:
                updateFieldCommand.value = value;
                break;
        }

        this.props.updateField(this.props.createdObject.id, updateFieldCommand);
        this.validation();
    }

    handleChange(event) {
        const target = event.currentTarget;

        if (target.type === 'checkbox') {
            this.updateField(event);
        }

        const newState = {};
        newState[target.name] = target.value;

        this.setState(newState);
    }

    validation() {
        let isGeneralInformationValid = true;
        console.log('hello')
        if (this.state.DESCRIPTION.length < 200) {
            isGeneralInformationValid = false;
        }

        console.log(this.state.DISPLAY_NAME.length)
        if (this.state.DISPLAY_NAME.length > 50) {
            isGeneralInformationValid = false;
        }

        if (this.state.COUNT_GUEST.length === 0 || this.state.COUNT_GUEST < 1) {
            isGeneralInformationValid = false;
        }

        if (this.state.COUNT_BEDS.length === 0 || this.state.COUNT_BEDS < 1) {
            isGeneralInformationValid = false;
        }

        if (this.state.COUNT_BEDROOMS.length === 0 || this.state.COUNT_BEDROOMS < 1) {
            isGeneralInformationValid = false;
        }

        if (this.state.COUNT_BATHROOM.length === 0 || this.state.COUNT_BATHROOM < 1) {
            isGeneralInformationValid = false;
        }

        if (this.state.AREA.length === 0 || this.state.AREA < 1) {
            isGeneralInformationValid = false;
        }

        if (this.props.isGeneralInformationValid !== isGeneralInformationValid) {
            this.props.setGeneralInformationValid(isGeneralInformationValid);
        }
    }

    render() {
        const {
            i18n,
            configuration: {
                object: {
                    typeApartmentsRent,
                    typeApartmentsSell
                }
            },
            creatingObjectPage: {
                createdObject: {
                    props: {
                        type
                    }
                }
            }
        } = this.props;
        const {RANGE_TYPE} = this.state;

        return (
            <div className={
                this.props.isActive ? 'clearfix tab_content animated show active' : 'clearfix tab_content animated show'
            }>
                <div className="heading">
                    <h3>
                        {i18n['creatingObjectPage.generalInformation']}
                    </h3>
                </div>

                {this.props.permissions.indexOf("rentamania.property.sell") != -1 && <div className="tablebox middle crumbs auto mt30">
                    <div>
                        {i18n['creatingObjectPage.generalInformation.doUouWantTo']}
                    </div>
                    <div className={type === ObjectConst.TYPE.RENT ? '' : 'active'}>
                        <a href="" onClick={event => this.handleTypeClick(event, ObjectConst.TYPE.RENT)}>
                            {i18n['creatingObjectPage.generalInformation.handOverObject']}
                        </a>
                    </div>
                    <div className={type === ObjectConst.TYPE.SELL ? '' : 'active'}>
                        <a href="" onClick={event => this.handleTypeClick(event, ObjectConst.TYPE.SELL)}>
                            {i18n['creatingObjectPage.generalInformation.sellObject']}
                        </a>
                    </div>
                </div>}

                <div className="clearfix mt30">
                    <label className="">
                        <span className="info">
                            <i className="fa fa-question-circle"/>
                            <span>
                                {i18n['creatingObjectPage.generalInformation.hint1']}
                            </span>
                        </span>
                        {i18n['creatingObjectPage.generalInformation.headline']}:
                        <textarea
                            onBlur={::this.updateField}
                            onChange={::this.handleChange}
                            value={this.state.DISPLAY_NAME}
                            name={ObjectConst.FIELDS.DISPLAY_NAME}
                            className={this.state.DISPLAY_NAME.length > 50 ? 'invalid' : ''}
                            placeholder={i18n['creatingObjectPage.generalInformation.enterTheTitleOfYourAd']}
                        />
                    </label>

                    <div className="grid grid-width-1-3">
                        <div>
                            <label>
                        <span className="info">
                            <i className="fa fa-question-circle"/>
                            <span>{i18n['creatingObjectPage.generalInformation.propertyLanguage.hint']}:</span>
                        </span>
                                {i18n['creatingObjectPage.generalInformation.propertyLanguage']}:
                                <select
                                    onBlur={::this.updateField}
                                    onChange={::this.handleChange}
                                    value={this.state.LANGUAGE_CODE}
                                    name={ObjectConst.FIELDS.LANGUAGE_CODE}
                                >
                                    {this.props.allLanguages.map(item =>
                                        <option key={item.code} value={item.code}>{item.code}</option>
                                    )}
                                </select>
                            </label>
                        </div>
                    </div>

                    <div className="grid grid-width-1-3">
                        <div>
                            <label>
                        <span className="info">
                            <i className="fa fa-question-circle"/>
                            <span>{i18n['creatingObjectPage.generalInformation.hint2']}</span>
                        </span>
                                {i18n['creatingObjectPage.generalInformation.objectType']}:
                                <select
                                    onBlur={::this.updateField}
                                    onChange={::this.handleChange}
                                    value={this.state.TYPE_APARTMENT}
                                    name={ObjectConst.FIELDS.TYPE_APARTMENT}
                                >
                                    {type === ObjectConst.TYPE.RENT && typeApartmentsRent.map(item => {
                                            if (item.title !== null) {
                                                return <option key={item.value} value={item.value}>{item.title}</option>
                                            } else {
                                                return null;
                                            }
                                        }
                                    )}

                                    {type === ObjectConst.TYPE.SELL && typeApartmentsSell.map(item => {
                                            if (item.title !== null) {
                                                return <option key={item.value} value={item.value}>{item.title}</option>
                                            } else {
                                                return null;
                                            }
                                        }
                                    )}
                                </select>
                            </label>
                        </div>

                        {type === ObjectConst.TYPE.RENT && <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle"/>
                                    <span>{i18n['creatingObjectPage.generalInformation.ourExclusive.hint']}</span>
                                </span>
                                {i18n['creatingObjectPage.generalInformation.ourExclusive']}
                                <select
                                    value={RANGE_TYPE}
                                    onBlur={::this.updateField}
                                    onChange={::this.handleChange}
                                    name={ObjectConst.FIELDS.RANGE_TYPE}
                                >
                                    <option value={ObjectConst.RANGE_TYPE.EXCLUSIVE}>
                                        {i18n['creatingObjectPage.yes']}
                                    </option>
                                    <option value={ObjectConst.RANGE_TYPE.OTHER}>
                                        {i18n['creatingObjectPage.no']}
                                    </option>
                                </select>
                            </label>
                        </div>}
                    </div>

                    <div className="grid grid-width-1-3">
                        {type === ObjectConst.TYPE.RENT && <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle"/>
                                    <span>{i18n['creatingObjectPage.generalInformation.hint3']}</span>
                                </span>
                                {i18n['creatingObjectPage.generalInformation.numberOfBeds']}:
                                <input
                                    placeholder="0"
                                    onBlur={::this.updateField}
                                    value={this.state.COUNT_BEDS}
                                    onChange={::this.handleChange}
                                    name={ObjectConst.FIELDS.COUNT_BEDS}
                                    className={classnames({
                                        'invalid': this.state.COUNT_BEDS.length === 0 || this.state.COUNT_BEDS < 1
                                    })}
                                />
                            </label>
                        </div>}
                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle"/>
                                    <span>{i18n['creatingObjectPage.generalInformation.hint4']}</span>
                                </span>
                                {i18n['creatingObjectPage.generalInformation.numberOfBedrooms']}:
                                <input
                                    placeholder="0"
                                    onBlur={::this.updateField}
                                    onChange={::this.handleChange}
                                    value={this.state.COUNT_BEDROOMS}
                                    name={ObjectConst.FIELDS.COUNT_BEDROOMS}
                                    className={classnames({
                                        'invalid': this.state.COUNT_BEDROOMS.length === 0 || this.state.COUNT_BEDROOMS < 1
                                    })}
                                />
                            </label>
                        </div>
                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle"/>
                                    <span>{i18n['creatingObjectPage.generalInformation.hint5']}</span>
                                </span>
                                {i18n['creatingObjectPage.generalInformation.bathrooms']}:
                                <input
                                    placeholder="0"
                                    onBlur={::this.updateField}
                                    onChange={::this.handleChange}
                                    value={this.state.COUNT_BATHROOM}
                                    name={ObjectConst.FIELDS.COUNT_BATHROOM}
                                    className={classnames({
                                        'invalid': this.state.COUNT_BATHROOM.length === 0 || this.state.COUNT_BATHROOM < 1
                                    })}
                                />
                            </label>
                        </div>
                    </div>

                    <div className="grid grid-width-1-3 cl">
                        {type === ObjectConst.TYPE.RENT && <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle"/>
                                    <span>{i18n['creatingObjectPage.generalInformation.hint6']}</span>
                                </span>
                                {i18n['creatingObjectPage.generalInformation.accommodatesGuests']}:
                                <input
                                    placeholder="0"
                                    onBlur={::this.updateField}
                                    value={this.state.COUNT_GUEST}
                                    onChange={::this.handleChange}
                                    name={ObjectConst.FIELDS.COUNT_GUEST}
                                    className={classnames({
                                        'invalid': this.state.COUNT_GUEST.length === 0 || this.state.COUNT_GUEST < 1
                                    })}
                                />
                            </label>
                        </div>}
                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle"/>
                                    <span>{i18n['creatingObjectPage.generalInformation.hint7']}</span>
                                </span>
                                {i18n['creatingObjectPage.generalInformation.totalArea']}:
                                <input
                                    placeholder="0"
                                    value={this.state.AREA}
                                    onBlur={::this.updateField}
                                    onChange={::this.handleChange}
                                    name={ObjectConst.FIELDS.AREA}
                                    className={classnames({
                                        'invalid': this.state.AREA.length === 0 || this.state.AREA < 1
                                    })}
                                />
                            </label>
                        </div>

                        <div>
                            <label>
                                <span className="info">
                                    <i className="fa fa-question-circle"/>
                                    <span>{i18n['creatingObjectPage.generalInformation.hint7']}</span>
                                </span>
                                {i18n['creatingObjectPage.generalInformation.terrace']}:
                                <input
                                    placeholder="0"
                                    value={this.state.TERRACE}
                                    onBlur={::this.updateField}
                                    onChange={::this.handleChange}
                                    name={ObjectConst.FIELDS.TERRACE}
                                />
                            </label>
                        </div>
                    </div>

                    <label>
                        <span className="info">
                            <i className="fa fa-question-circle"/>
                            <span>
                                {i18n['creatingObjectPage.generalInformation.hint8']}
                            </span>
                        </span>
                        {i18n['creatingObjectPage.generalInformation.descriptionOfTheObject']}:
                        <textarea
                            onBlur={::this.updateField}
                            onChange={::this.handleChange}
                            value={this.state.DESCRIPTION}
                            name={ObjectConst.FIELDS.DESCRIPTION}
                            className={this.state.DESCRIPTION.length < 200 ? 'invalid' : ''}
                            placeholder={i18n['creatingObjectPage.generalInformation.featuresOfHousingAndItsInfrastructure']}
                        />
                    </label>

                    <div className="clearfix options check grid grid-width-1-4 cl">

                    </div>

                    <label>
                        <span className="info">
                            <i className="fa fa-question-circle"/>
                            <span>
                                {i18n['creatingObjectPage.generalInformation.hint9']}
                            </span>
                        </span>
                        {i18n['creatingObjectPage.generalInformation.commentRentamania']}:
                        <textarea
                            placeholder={i18n['creatingObjectPage.generalInformation.description']}
                            onBlur={::this.updateField}
                            onChange={::this.handleChange}
                            value={this.state.RENT_COMMENT}
                            name={ObjectConst.FIELDS.RENT_COMMENT}
                        />
                    </label>

                    {false && <AddFilter disabled={true}/>}
                </div>
            </div>
        )
    }
}

GeneralInformation.propTypes = propTypes;
GeneralInformation.defaultProps = defaultProps;

const mapStateToProps = state => ({
    allLanguages: state.languages.allLanguages,
    i18n: state.languages.i18n,
    configuration: state.configuration,
    creatingObjectPage: state.creatingObjectPage,
    createdObject: state.creatingObjectPage.createdObject,
    isGeneralInformationValid: state.creatingObjectPage.validation.isGeneralInformationValid,
    permissions: state.user.currentUser.permissions,
});

const mapDispatchToProps = {
    updateField,
    setGeneralInformationValid
};

export default connect(mapStateToProps, mapDispatchToProps)(GeneralInformation);



// WEBPACK FOOTER //
// ./src/components/CreatingProperty/GeneralInformation.js